import React, { useState, useEffect, useRef } from "react";
import "./query.scss";
import Sidebar from "../Sidebar";
import { querylistAction, queryCategorylistAction, assigneeListAction } from "../../actions/queryAction";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { encode } from "base-64";
import Header from "../../component/loaderComponent/Header/Header";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import { useSelector } from "react-redux";
import { searchQueryAction, pageQueryAction } from "../../actions/queryAction";
import { Image_Url } from "../../ImageUrl/ImageUrl";
import { dowloadsupportqueryAction } from "../../actions/exceldownloadAction";
import { notify } from '../../services/notification';
import { constant } from "../../constants/constant";
import Loader from "../../component/loaderComponent/loaderComponent/Loader";
import NoDataFound from "../../component/noDataComponent/NoDataFound";
import { HTTP_STATUS } from "../../constants/httpsStatus/httpsStatus";
import { HiMenu, HiX } from "react-icons/hi";
import { MOBILE_BREAKPOINT } from "../../constants/constant";
import useMobileView from "../../constants/useMobileView";

const USER_PERSONA_OPTIONS = [
  { value: "pgm", label: "PGM" },
  { value: "retailer", label: "Retailer" },
  { value: "dsr", label: "DSR" },
];

const SEARCH_BY_OPTIONS = [
  { value: "query_id", label: "Query ID" },
  { value: "user_id", label: "User ID" },
  { value: "account_number", label: "User Account No" },
  { value: "mobile_number", label: "User Mobile No" },
];

function Query() {
  const [startIndex, setStartIndex] = useState(1);
  const searchdata = useSelector((state) => state?.querySearch);
  const pagedata = useSelector((state) => state?.querpage);
  const isInitialMount = useRef(true);
  const { isSidebarOpen, toggleSidebar } = useMobileView();

  const [checkDate, setCheckDate] = useState(null);

  const [page, setPage] = useState(pagedata?.page || 1);
  const [state, setDataState] = useState({
    status: searchdata?.searchquerydata?.data?.value || "",
    fromDate: searchdata?.searchquerydata?.data?.fromDate || "",
    toDate: searchdata?.searchquerydata?.data?.toDate || "",
    persona: "",
    categoryId: "",
    assignedTo: "",
    searchBy: "query_id",
    searchValue: "",
  });

  // Ref to always hold the latest filters for use in pagination
  const filtersRef = useRef(state);
  useEffect(() => {
    filtersRef.current = state;
  }, [state]);

  const [isLoading, setLoading] = useState(false);
  const [querylist, setquerylist] = useState([]);
  const [categoryList, setCategoryList] = useState([]);
  const [assigneeList, setAssigneeList] = useState([]);
  const [count, setCount] = useState(1);
  const [paginationListcount, setpaginationListcount] = useState(0);

  const isSearchDisabled = !(state.fromDate && state.toDate);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  useEffect(() => {
    fetchCategoryList();
    fetchAssigneeList();
  }, []);

  async function fetchCategoryList(userType) {
    const response = await dispatch(queryCategorylistAction(userType));
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setCategoryList(response?.data?.data || []);
    }
  }

  async function fetchAssigneeList() {
    const response = await dispatch(assigneeListAction());
    if (response?.status === HTTP_STATUS.SUCCESS) {
      setAssigneeList(response?.data?.data.results || []);
    }
  }

  // Dropdown filters that auto-trigger API call on change
  const AUTO_FETCH_FILTERS = ["persona", "categoryId", "status", "assignedTo"];

  const handleFilterChange = (evt) => {
    const { name, value } = evt.target;
    let updatedState = { ...state, [name]: value };

    // When persona changes, reset categoryId and re-fetch category list filtered by user_type
    if (name === "persona") {
      updatedState = { ...updatedState, categoryId: "" };
      fetchCategoryList(value);
    }

    setDataState(updatedState);

    // Auto-fetch when dropdown filters change (not for text inputs like searchValue/searchBy)
    if (AUTO_FETCH_FILTERS.includes(name)) {
      filtersRef.current = updatedState;
      dispatch(pageQueryAction(1));
      setLoading(true);
      if (page === 1) {
        fetchQueries(1, updatedState);
      } else {
        setPage(1);
      }
    }
  };

  var today = new Date().toISOString().split("T")[0];
  const handleDateChange = (evt) => {
    const { name, value } = evt.target;

    // Handle clear button — value is empty string, fetch full list
    if (!value) {
      const updatedState = name === "fromDate"
        ? { ...state, fromDate: "", toDate: "" }
        : { ...state, toDate: "" };
      setDataState(updatedState);
      filtersRef.current = updatedState;
      setCheckDate(null);
      dispatch(pageQueryAction(1));
      setLoading(true);
      if (page === 1) {
        fetchQueries(1, updatedState);
      } else {
        setPage(1);
      }
      return;
    }

    const today = new Date().toISOString().split("T")[0];
    if (value > today) {
      notify.error("Future dates are not allowed.");
      return;
    }
    setCheckDate(true);
    if (name === "fromDate") {
      const maxDate = new Date(value);
      maxDate.setDate(maxDate.getDate() + 31);
      setDataState((prevState) => ({
        ...prevState,
        toDate: prevState.toDate && prevState.toDate > maxDate.toISOString().split("T")[0] ? "" : prevState.toDate,
        [name]: value,
      }));
    } else if (name === "toDate") {
      setDataState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  // Core fetch function — takes explicit params to avoid stale closure issues
  async function fetchQueries(pageNum, filters) {
    const { fromDate, toDate, status, persona, categoryId, assignedTo, searchBy, searchValue } = filters;
    const response = await dispatch(querylistAction(
      pageNum,
      status,
      fromDate,
      toDate,
      persona,
      categoryId,
      assignedTo,
      searchValue ? searchBy : "",
      searchValue
    ));

    if (response?.status === HTTP_STATUS.SUCCESS) {
      const totalCount = response?.data?.data?.count ?? constant.defaultPageZero;
      setCount(Math.ceil(totalCount / 10));
      setquerylist(response?.data?.data?.results || []);
      setpaginationListcount(totalCount);
    } else {
      setquerylist([]);
      setCount(1);
      setpaginationListcount(constant.defaultPageZero);
    }
    setLoading(false);
  }

  // Pagination change — always uses latest filters from ref
  const handlePagiChange = (event, value) => {
    dispatch(pageQueryAction(value));
    setPage(value);
  };

  useEffect(() => {
    setLoading(true);
    fetchQueries(page, filtersRef.current);
  }, [page]);

  // Search button click
  async function searcData() {
    setLoading(true);
    const seardata = {
      value: state?.status,
      fromDate: state?.fromDate,
      toDate: state?.toDate,
    };
    dispatch(searchQueryAction(seardata));
    dispatch(pageQueryAction(1));

    if (page === 1) {
      // page won't change, so useEffect won't fire — call directly
      await fetchQueries(1, state);
    } else {
      // setting page to 1 will trigger useEffect which calls fetchQueries
      setPage(1);
    }
  }

  async function downloadquerylist() {
    try {
      const { fromDate, toDate, status } = state;

      if (!fromDate || !toDate) {
        notify.error('Please select both from and to dates.');
        return;
      }

      const formattedFromDate = new Date(fromDate).toISOString().split('T')[0];
      const formattedToDate = new Date(toDate).toISOString().split('T')[0];

      const fileBlob = await dispatch(dowloadsupportqueryAction(formattedFromDate, formattedToDate, status));

      if (fileBlob) {
        const blobUrl = URL.createObjectURL(fileBlob);
        const newWindow = window.open(blobUrl, '_blank');
        if (newWindow) {
          newWindow.focus();
        } else {
          notify.error('Popup blocked. Please allow popups for this website');
        }
      }
    } catch (error) {
      notify.error('Error downloading file:', error);
    }
  }

  const queryDetails = (Id) => {
    window.scroll(0, 0);
    const encodeid = encode(Id);
    navigate(`/viewquery/${encodeid}`);
  };

  const startItem = (!querylist || querylist?.length === 0)
    ? 0
    : (page - 1) * constant.paginationCount + 1;
  const endItem = Math.min((page ?? 1) * (constant.paginationCount ?? 10), paginationListcount ?? 0);

  // Reset — clears all filters and fetches fresh unfiltered data
  const handleReset = async () => {
    const emptyFilters = {
      status: "",
      fromDate: "",
      toDate: "",
      persona: "",
      categoryId: "",
      assignedTo: "",
      searchBy: "query_id",
      searchValue: "",
    };
    setDataState(emptyFilters);
    filtersRef.current = emptyFilters;
    setCheckDate(null);
    fetchCategoryList(); // Reset to full unfiltered category list
    dispatch(searchQueryAction({ value: "", fromDate: "", toDate: "" }));
    dispatch(pageQueryAction(1));

    setLoading(true);
    if (page === 1) {
      // page won't change, so useEffect won't fire — call directly
      await fetchQueries(1, emptyFilters);
    } else {
      // setting page to 1 triggers useEffect, which reads filtersRef (already cleared)
      setPage(1);
    }
  };

  return (
    <div className="support-query">
      <div className="Query_Containers">
        <div className="Query_Containers_right">
          <Header title="PGM Support Query" />
          {isLoading ? (
            <Loader />
          ) : (

            <div className="Queery_Special">
              {/* Unified Filter & Search Section */}
              <div className="query-filters-container">
                <div className="query-filters-grid">
                  <div className="filter-field">
                    <label className="filter-label">User Persona</label>
                    <select name="persona" className="filter-control" value={state.persona} onChange={handleFilterChange}>
                      <option value="">All Persona</option>
                      {USER_PERSONA_OPTIONS?.map((opt) => (
                        <option key={opt.value} value={opt.value}>{opt.label}</option>
                      ))}
                    </select>
                  </div>
                  <div className="filter-field">
                    <label className="filter-label">Query Category</label>
                    <select name="categoryId" className="filter-control" value={state.categoryId} onChange={handleFilterChange}>
                      <option value="">All Categories</option>
                      {categoryList?.map((cat) => (
                        <option key={cat?.id} value={cat?.id}>{cat?.category}</option>
                      ))}
                    </select>
                  </div>
                  <div className="filter-field">
                    <label className="filter-label">Query Status</label>
                    <select name="status" className="filter-control" value={state.status} onChange={handleFilterChange}>
                      <option value="">All Status</option>
                      <option value="OPEN">Open</option>
                      <option value="CLOSED">Closed</option>
                    </select>
                  </div>
                  <div className="filter-field">
                    <label className="filter-label">Assigned To</label>
                    <select name="assignedTo" className="filter-control" value={state.assignedTo} onChange={handleFilterChange}>
                      <option value="">All Assignees</option>
                      {assigneeList?.map((assignee) => (
                        <option key={assignee?.id} value={assignee?.id}>{assignee?.name}</option>
                      ))}
                    </select>
                  </div>
                  <div className="filter-field">
                    <label className="filter-label">From Date
                      <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="fromDate"
                      value={state.fromDate}
                      max={today}
                      onChange={handleDateChange}
                      className="filter-control"
                    />
                  </div>
                  <div className="filter-field">
                    <label className="filter-label">To Date
                      <span className="required">*</span>
                    </label>
                    <input
                      type="date"
                      name="toDate"
                      value={state.toDate}
                      min={state.fromDate}
                      max={today}
                      onChange={handleDateChange}
                      className="filter-control"
                    />
                  </div>
                </div>

                {/* Search Bar */}
                <div className="query-search-bar">
                  <select name="searchBy" className="search-by-select" value={state.searchBy} onChange={handleFilterChange}>
                    {SEARCH_BY_OPTIONS?.map((opt) => (
                      <option key={opt?.value} value={opt?.value}>{opt?.label}</option>
                    ))}
                  </select>
                  <input
                    type="text"
                    name="searchValue"
                    className="search-input"
                    placeholder={`Search by ${SEARCH_BY_OPTIONS.find(o => o.value === state.searchBy)?.label || ''}...`}
                    value={state.searchValue}
                    onChange={handleFilterChange}
                  />
                  <div className="search-actions">
                    <button className="btn-search" onClick={searcData} 
                    disabled={isSearchDisabled}
                    >
                      Search
                    </button>
                    <button className="btn-reset" onClick={handleReset}>
                      Reset
                    </button>
                    <button className="btn-download" onClick={downloadquerylist}>
                      <img src={Image_Url.EXCEL_LOGO} className="downloads_imgdexcel" alt="excel" />
                      Download Excel
                    </button>
                  </div>
                </div>
              </div>

              {/* Table */}
              {querylist && querylist.length > 0 ? (
                <div className="tabledata">
                  <table className="table">
                    <thead>
                      <tr>
                        <th className="tablesth">Query ID</th>
                        <th className="tablesth">Persona</th>
                        <th className="tablesth">Query Category</th>
                        <th className="tablesth">User ID</th>
                        <th className="tablesth">User Account No</th>
                        <th className="tablesth">User Mobile No</th>
                        <th className="tablesth query_text">Title</th>
                        <th className="tablesth">Status</th>
                        <th className="tablesth">Assigned To</th>
                        <th className="tablesth">Created Date & Time</th>
                        {/* <th className="tablesth">Action</th> */}
                      </tr>
                    </thead>
                    <tbody>
                      {querylist?.map((item, index) => (
                        <tr key={index}>
                          <td className="tabletd">
                            <span className="query-id-link" onClick={() => queryDetails(item?.id)}>{item?.id}</span>
                          </td>
                          <td className="tabletd">{item?.user_type || '-'}</td>
                          <td className="tabletd">{item?.category || '-'}</td>
                          <td className="tabletd">{item?.pgm || '-'}</td>
                          <td className="tabletd">{item?.account_number || '-'}</td>
                          <td className="tabletd">{item?.mobile_number || '-'}</td>
                          <td className="tabletd query_text" title={item?.query}>{item?.query}</td>
                          <td className="tabletd">
                            <span className={`status-badge status-${item?.status?.toLowerCase()}`}>
                              {item?.status}
                            </span>
                          </td>
                          <td className="tabletd">{item?.assigned_to?.email || '-'}</td>
                          <td className="tabletd">{item?.created_at_date} {item?.created_at_time}</td>
                          {/* <td>
                            <div className="btn view_text" onClick={() => queryDetails(item?.id)}>View</div>
                          </td> */}
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>
              ) : (
                <div className="no-data-container">
                  <NoDataFound />
                </div>
              )}

              <div className="Pagination_section">
                <Stack spacing={2} >
                  <Pagination
                    count={count}
                    className="pagination"
                    page={page}
                    size="medium"
                    defaultPage={1}
                    color="primary"
                    onChange={handlePagiChange}
                  />
                </Stack>
                <div className="count">
                  <b>
                    <span>Displaying {startItem} to {endItem} out of {paginationListcount}</span>
                  </b>
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
export default Query;
 